__turbopack_context__.v({
  "panelRight": "DeliveryRightPanel-module__Qm0Dka__panelRight",
});
